const ErrorIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 36" {...props}>
    <path d="M18 36C8.075 36 0 27.925 0 18S8.075 0 18 0s18 8.075 18 18-8.075 18-18 18zm0-33.677C9.356 2.323 2.323 9.356 2.323 18c0 8.644 7.033 15.677 15.677 15.677 8.644 0 15.677-7.033 15.677-15.677 0-8.644-7.033-15.677-15.677-15.677z" />
    <path d="M23.143,10.286l2.571,2.571l-5.143,5.143l5.143,5.143l-2.571,2.571l-5.143,-5.143l-5.143,5.143l-2.571,-2.571l5.143,-5.143l-5.143,-5.143l2.571,-2.571l5.143,5.143l5.143,-5.143Z" />
  </svg>
);

export default ErrorIcon;
